import { useMemo } from 'react';
import { ActionType } from '../../types';
import { ALERT_CONFIGS, DEFAULT_PROMOTER_NAME } from './config';
import { AlertConfig } from './types';

const useAlertConfig = (
  action: ActionType,
  promoterName?: string
): { config: AlertConfig; finalPromoterName: string } => {
  const config = useMemo(
    () => ALERT_CONFIGS[action] || ALERT_CONFIGS.approve,
    [action]
  );

  const finalPromoterName = promoterName || DEFAULT_PROMOTER_NAME;

  return {
    config,
    finalPromoterName,
  };
};

export default useAlertConfig;
